import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AuthRoutes, AdminRoutes, Path } from "./routes/routes";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-center" autoClose={2000} hideProgressBar={false} />
      <Routes>
        {AuthRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path={AdminRoutes.path} element={AdminRoutes.element}>
          {AdminRoutes.children.map(({ path, element, index }, i) => (
            <Route key={path || `index-${i}`} path={path} element={element} index={index} />
          ))}
        </Route>
        <Route path="/" element={<Navigate to={Path.Login} replace />} />
        <Route path="*" element={<Navigate to={Path.Login} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
